import { SidebarItemsType } from "@/types/sidebar";
import SidebarNavSection from "./SidebarNavSection";

type SidebarNavProps = {
  items: {
    title: string;
    pages: SidebarItemsType[];
  }[];
  collapsed?: boolean;
};

function SidebarNav({ items, collapsed = false }: SidebarNavProps) {
  return (
    <div className="flex-grow border-r border-black/10 bg-sidebar-background">
      <div className="py-2.5">
        {items.map((item) => (
          <SidebarNavSection
            component="div"
            key={item.title}
            pages={item.pages}
            title={item.title}
            collapsed={collapsed}
          />
        ))}
      </div>
    </div>
  );
}

export default SidebarNav;
